import axios from "axios";

  export const uploadImage = async (category, image) => {
    
        try {
            const formData = new FormData();
            formData.append('file', image);
            
            const response = await axios.post(`/files/upload/${category}`, formData, {
                headers: {
                'Accept': '*/*',
                'Content-Type': 'multipart/form-data',
                },
            });

            return response;
            
        } catch (error) {
            console.error('Erreur lors de l\'upload de l\'image:', error);
            throw error;
        }
  };

  export const getAllMedia = async () => {
      try {
        const response = await axios.get(`/files/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getMediaById = async (fileName) => {
    
      try {
        const response = await axios.get(`/files/${fileName}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const downloadMedia = async ( fileName) => {
      try {
        const response = await axios.get(`/files/download/${fileName}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteMedia = async (fileName) => {
    try {
        const response = await axios.delete(`/files/${fileName}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  
  export const uploadManyFilesBusiness = async (files) => {
    
    try {
      const formData = new FormData();

      if (files.businessRegistry) {
        formData.append("businessRegistry", files.businessRegistry);
      }
      if (files.ninea) {
        formData.append("ninea", files.ninea);
      }
      if (files.statut) {
        formData.append("statut", files.statut);
      }

      const response = await axios.post(`/developer-accounts/business-documents`,
        formData,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response;
    } catch (error) {
      console.error("Erreur upload multiple:", error);
      throw error;
    }
  };
  
  export const uploadFilesBusinessById = async (id, files) => {
    try {
      const formData = new FormData();

      if (files.businessRegistryFileName) {
        formData.append("businessRegistryFileName", files.businessRegistryFileName);
      }
      if (files.nineaFileName) {
        formData.append("nineaFileName", files.nineaFileName);
      }
      if (files.statutFileName) {
        formData.append("statutFileName", files.statutFileName);
      }

      const response = await axios.post(`/developer-accounts/business-registry/${id}`,
        formData,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response;
    } catch (error) {
      console.error("Erreur upload multiple:", error);
      throw error;
    }
  };
  
  export const deleteManyFilesBusiness = async (files) => {
    try {
      const formData = new FormData();

      if (files.businessRegistry) {
        formData.append("businessRegistry", files.businessRegistry);
      }
      if (files.ninea) {
        formData.append("ninea", files.ninea);
      }
      if (files.statut) {
        formData.append("statut", files.statut);
      }

      const response = await axios.delete(
        `/developer-accounts/business-documents`,
        formData,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response;
    } catch (error) {
      console.error("Erreur upload multiple:", error);
      throw error;
    }
  };
    
  export const deleteAllDocuments = async (data) => {
    try {
      const response = await axios.delete(`/developer-accounts/documents`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };